import { scroller } from "react-scroll";

function scrollToSection(sectionId: string) {
  scroller.scrollTo(sectionId, {
    duration: 700,
    smooth: true,
    offset: -10,
  })
}

export default scrollToSection;
